<template>
  <div id="rules" class="under-header padding-bottom">
    <div class="container">
      <div class="panel large">
        <div class="text-centered">
          <img src="/assets/img/mapas.jpg" alt="map" style="width: 80%">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maps',
};
</script>

<style scoped>
</style>
